export default {
  activeCall: 'Active Call',
} as const;
